import { withRouter } from 'react-router-dom';
import React from 'react';
import { getSlaughterhouseSpecificComponent } from './slaughterhouseSpecific';

export const BottomMenu = withRouter(({ location, history }) => {
  const Component = getSlaughterhouseSpecificComponent('bottomMenu');

  return <Component location={location} history={history} />;
});
